import moment from "moment";

export const combineDateAndTime = (date, time) => {
    const combinedDateTime = moment(`${date} ${time}`, 'YYYY-MM-DD HH:mm');
    const formattedDateTime = combinedDateTime.format('YYYY-MM-DD HH:mm:ss');

    return new Date(formattedDateTime)
};

export const combineTime = (time , duration) =>{
    const parsedBaseTime = moment(time, 'HH:mm');

    const combinedTime = parsedBaseTime.add(duration, 'hours');

    const formattedTime = combinedTime.format('HH:mm');

    return new Date(formattedTime)
}